var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResourcesFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19922 5C3.54236 5 2.19922 6.34315 2.19922 8V14C2.19922 15.6569 3.54236 17 5.19922 17H11.1992C12.8561 17 14.1992 15.6569 14.1992 14V8C14.1992 6.34315 12.8561 5 11.1992 5H5.19922ZM9.94922 8.25C9.94922 9.2165 9.16572 10 8.19922 10C7.23272 10 6.44922 9.2165 6.44922 8.25C6.44922 7.2835 7.23272 6.5 8.19922 6.5C9.16572 6.5 9.94922 7.2835 9.94922 8.25ZM11.6992 12.25C11.6992 12.8377 11.5536 14.75 8.19714 14.75C4.8407 14.75 4.69922 12.8213 4.69922 12.25C4.69922 11.6978 5.14682 11.25 5.69902 11.25H10.6992C11.2515 11.25 11.6992 11.6977 11.6992 12.25ZM4.9631 18C5.51242 18.6138 6.31071 19 7.19921 19H11.6992C14.1845 19 16.1992 16.9853 16.1992 14.5V10C16.1992 9.11152 15.813 8.31324 15.1992 7.76392V14.5C15.1992 16.433 13.6322 18 11.6992 18H4.9631Z",
    fill: "#342C82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesFilled);
export default __webpack_public_path__ + "static/media/ResourcesFilled.8663f585797568cc334029ffe02ea510.svg";
export { ForwardRef as ReactComponent };